import { render } from "./PositionRow.vue?vue&type=template&id=5238c2bd&scoped=true&ts=true"
import script from "./PositionRow.vue?vue&type=script&lang=ts"
export * from "./PositionRow.vue?vue&type=script&lang=ts"

import "./PositionRow.vue?vue&type=style&index=0&id=5238c2bd&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5238c2bd"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});
